import styled from "styled-components";
import theme from "../../Styles/theme";
export const Span = styled.span`

    color:${theme.colors.dark};
    display: flex;
    align-items: center;
    justify-content:center;

    cursor: pointer;

    &:hover{
        opacity: 0.8;
    }

`;

export const HelperSpan = styled.span`
margin-right:min(1vw, 5px);
`;